

export class ApplicationModuleOutputWithStatus implements IApplicationModuleOutputWithStatus {
    /** The auto-generated id of the application module master */
    application_module_id!: number;
    /** The application module name with 255 character limit */
    application_module_name!: string;
    /** The application module image with 2048 character limit */
    application_module_image!: string;
    /** Manage status of application module . 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IApplicationModuleOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application_module_id = _data["application_module_id"];
            this.application_module_name = _data["application_module_name"];
            this.application_module_image = _data["application_module_image"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ApplicationModuleOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationModuleOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application_module_id"] = this.application_module_id;
        data["application_module_name"] = this.application_module_name;
        data["application_module_image"] = this.application_module_image;
        data["status"] = this.status;
        return data; 
    }
}

export interface IApplicationModuleOutputWithStatus {
    /** The auto-generated id of the application module master */
    application_module_id: number;
    /** The application module name with 255 character limit */
    application_module_name: string;
    /** The application module image with 2048 character limit */
    application_module_image: string;
    /** Manage status of application module . 0 For De-active, 1 For Active */
    status: number;
}

